export default [
  {
    path: '/politica-de-privacidade',
    name: 'politica-de-privacidade',
    component: () => import('@/app-modulo/comuns/policies/PoliticaPrivacidade.vue'),
    meta: {
      resource: 'politica-de-privacidade',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
  {
    path: '/politica-de-uso',
    name: 'politica-de-uso',
    component: () => import('@/app-modulo/comuns/policies/PoliticaUso.vue'),
    meta: {
      resource: 'politica-de-uso',
      action: 'auditar',
      requiredAuth: false,
      layout: 'full',
    },
  },
]
